// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"wrapper___096WP","notification":"notification___4Xq5N","iconWrapper":"iconWrapper___p3qWu","title":"title___NAf2i","link":"link___yRVry"};